import React from 'react'
import IndexTable from './index-table'

function UITemplate(props) {
  return (
    <div>
      <IndexTable />
    </div>
  )
}

export default UITemplate
